/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Created_SuccessInputs */

const en_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD template created successfully`)
};

const fr_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle AD créé avec succès`)
};

const de_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Vorlage erfolgreich erstellt`)
};

const it_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello di annuncio creato con successo`)
};

const ru_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблон объявления успешно создан.`)
};

const es_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla de AD creada exitosamente`)
};

const zh_cn2_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD模板创建成功`)
};

const ja_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD テンプレートが正常に作成されました`)
};

const hi_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD टेम्पलेट सफलतापूर्वक बनाया गया`)
};

const pt_pt2_ad_template_created_success = /** @type {(inputs: Ad_Template_Created_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de anúncio criado com sucesso`)
};

/**
* | output |
* | --- |
* | "AD template created successfully" |
*
* @param {Ad_Template_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_created_success = /** @type {((inputs?: Ad_Template_Created_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Created_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_created_success(inputs)
	if (locale === "de") return de_ad_template_created_success(inputs)
	if (locale === "it") return it_ad_template_created_success(inputs)
	if (locale === "ru") return ru_ad_template_created_success(inputs)
	if (locale === "es") return es_ad_template_created_success(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_created_success(inputs)
	if (locale === "ja") return ja_ad_template_created_success(inputs)
	if (locale === "hi") return hi_ad_template_created_success(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_created_success(inputs)
	return en_ad_template_created_success(inputs)
});